import { useEffect, useState } from 'react';

import { getTzFromNumber } from '../utils/getTzFromNumber';
import { signedTimeZoneOffsetHours } from '../utils/signedTimeZoneOffsetHours';
import { useUserTimeSettings } from './useUserTimeSettings';

/**
 * Разошёлся ли пояс профиля с поясом устройства.
 *
 * Нужен экранам, где напоминание «ваше время такое-то, поменять можно в настройках» имеет
 * смысл только при расхождении: если время на экране и так совпадает с часами телефона,
 * объяснять нечего, а место напоминание занимает.
 *
 * Сравниваем не сырой `timeZoneOffset`, а `timeZoneName` из `useUserTimeSettings` — ровно то
 * значение, в котором экран и печатает время. Мусорные пояса (в базе встречаются минуты
 * вместо часов) этот хук уже отбросил, и время в таком профиле показывается по устройству:
 * расхождения нет, и говорить о нём было бы враньём.
 *
 * На сервере всегда `false`: `getTimezoneOffset()` там вернёт пояс машины рендера, и разметка
 * разъехалась бы с клиентской (react #418). Поэтому считаем после монтирования — так же, как
 * это делает экран настроек.
 */
export const useTimeZoneMismatch = (): boolean => {
  const { timeZoneName } = useUserTimeSettings();
  const [deviceTimeZoneName, setDeviceTimeZoneName] = useState<string | null>(null);

  useEffect(() => {
    setDeviceTimeZoneName(
      getTzFromNumber(signedTimeZoneOffsetHours(new Date().getTimezoneOffset()))
    );
  }, []);

  // Пока пояс устройства неизвестен или профиль не задал свой — считаем, что расхождения нет.
  if (!timeZoneName || deviceTimeZoneName === null) {
    return false;
  }

  return timeZoneName !== deviceTimeZoneName;
};
